var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sort-options-panel"}},[_c('span',[_vm._v("Sort by    ")]),_vm._v(" "),_c('sui-button-group',{attrs:{"icons":"","size":"small","id":"sort-options"}},[_c('sui-button',{attrs:{"icon":"star"},on:{"click":function($event){return _vm.onClickOption('star')}}}),_vm._v(" "),_c('sui-button',{attrs:{"icon":"fork"},on:{"click":function($event){return _vm.onClickOption('fork')}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d85ef48","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SortOptions.vue
// module id = 524
// module chunks = 0